<script lang="ts">
  import { onMount } from 'svelte';
  import { authStore } from '$lib/stores/auth';
  import '$lib/styles/global.css';

  let { children } = $props();

  onMount(() => {
    authStore.load();
  });
</script>

<svelte:head>
  <title>SIM EPK KEPK - FKM Universitas Jember</title>
</svelte:head>

<div class="min-h-screen flex flex-col">
  <header class="site-header">
    <nav class="container mx-auto px-4 py-3 flex items-center justify-between">
      <a href="/" class="site-logo">SIM EPK KEPK</a>
      <div class="flex items-center gap-6">
        {#if $authStore.isAuthenticated}
          <a href="/dashboard" class="nav-link">Dashboard</a>
          <a href="/submissions" class="nav-link">Pengajuan</a>
          <a href="/kepk" class="nav-link">KEPK</a>
          <span class="text-sm text-muted-foreground">{$authStore.user?.displayName}</span>
          <button class="btn" style="padding: 0.45rem 1.1rem; border-color: var(--border); background: transparent; color: var(--primary-800);" onclick={() => authStore.logout()}>
            Logout
          </button>
        {:else}
          <a href="/login" class="nav-link">Masuk</a>
          <a href="/register" class="btn bg-primary" style="padding: 0.5rem 1.25rem; font-size: 0.875rem;">Daftar</a>
        {/if}
      </div>
    </nav>
  </header>

  <main class="flex-1 container mx-auto px-4 py-6">
    {@render children()}
  </main>

  <footer class="site-footer">
    <div class="container mx-auto px-4 footer-grid">
      <div>
        <a href="/" class="site-logo">SIM EPK KEPK</a>
        <p class="text-sm mt-2" style="color: var(--neutral-600); max-width: 32rem;">
          Sistem Informasi Manajemen Evaluasi Protokol Komite Etik Penelitian Kesehatan —
          Fakultas Kesehatan Masyarakat, Universitas Jember.
        </p>
        <div class="footer-social mt-3">
          <a href="https://www.facebook.com/fkmuj" target="_blank" rel="noopener noreferrer" aria-label="Facebook FKM UNEJ" class="footer-social-link">
            <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor" aria-hidden="true"><path d="M22 12.06C22 6.5 17.52 2 12 2S2 6.5 2 12.06c0 5 3.66 9.15 8.44 9.94v-7.03H7.9v-2.91h2.54V9.85c0-2.5 1.49-3.89 3.77-3.89 1.09 0 2.24.2 2.24.2v2.46h-1.26c-1.24 0-1.63.77-1.63 1.56v1.88h2.78l-.44 2.91h-2.34V22c4.78-.79 8.44-4.94 8.44-9.94Z"/></svg>
          </a>
          <a href="https://www.instagram.com/fkmunej" target="_blank" rel="noopener noreferrer" aria-label="Instagram FKM UNEJ" class="footer-social-link">
            <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><rect x="3" y="3" width="18" height="18" rx="5"/><circle cx="12" cy="12" r="4"/><circle cx="17.2" cy="6.8" r="1"/></svg>
          </a>
          <a href="https://www.youtube.com/channel/UCww2u61YyKcCwz5lrEFsRXQ" target="_blank" rel="noopener noreferrer" aria-label="YouTube FKM UNEJ" class="footer-social-link">
            <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor" aria-hidden="true"><path d="M22.5 12s0-3.2-.41-4.72a2.9 2.9 0 0 0-2.05-2.06C18.5 5 12 5 12 5s-6.5 0-8.04.22a2.9 2.9 0 0 0-2.05 2.06C1.5 8.8 1.5 12 1.5 12s0 3.2.41 4.72a2.9 2.9 0 0 0 2.05 2.06C5.5 19 12 19 12 19s6.5 0 8.04-.22a2.9 2.9 0 0 0 2.05-2.06c.41-1.52.41-4.72.41-4.72Z"/><path d="M9.75 15.02V8.98L15.5 12l-5.75 3.02Z" fill="#fff"/></svg>
          </a>
          <a href="https://linktr.ee/fkmunej" target="_blank" rel="noopener noreferrer" aria-label="Linktree FKM UNEJ" class="footer-social-link">
            <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="M12 21v-8"/><path d="M12 13 6 8h4L6 4h5l1 3 1-3h5l-4 4h4l-6 5Z"/></svg>
          </a>
        </div>
      </div>

      <div>
        <h2 class="footer-heading">Kunjungi kami</h2>
        <p class="text-sm" style="color: var(--neutral-600);">
          Jl. Kalimantan Kampus Bumi Tegalboto No. I/93,<br />
          Jember, Jawa Timur 68121
        </p>
        <a href="https://fkm.unej.ac.id" target="_blank" rel="noopener noreferrer" class="text-sm" style="color: var(--primary-700); font-weight: 500;">
          fkm.unej.ac.id →
        </a>
      </div>
    </div>

    <div class="footer-bottom text-center text-sm">
      SIM EPK KEPK - © 2026 Fakultas Kesehatan Masyarakat Universitas Jember
    </div>
  </footer>
</div>
